import React, { cloneElement } from 'react';
import Button from '../Button/Button.es.js';
import { getButtonIconSize } from '../Button/helpers.es.js';
import { Tooltip } from '../Tooltip/Tooltip.es.js';
import { ConditionalWrapper } from '../../primitives/ConditionalWrapper/ConditionalWrapper.es.js';
import { forwardRef } from '../../system/forwardRef.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const IconButton = forwardRef((_a, ref) => {
  var _b = _a, { label = "", children, as = "button", hideTooltip = false, icon: Icon, size = "md" } = _b, props = __objRest(_b, ["label", "children", "as", "hideTooltip", "icon", "size"]);
  const iconElement = /* @__PURE__ */ React.createElement(Icon, null) || children;
  return /* @__PURE__ */ React.createElement(ConditionalWrapper, {
    condition: !hideTooltip && !!label,
    wrapper: (children2) => /* @__PURE__ */ React.createElement(Tooltip, {
      content: label,
      position: "top",
      hasArrow: true
    }, /* @__PURE__ */ React.createElement(React.Fragment, null, children2))
  }, /* @__PURE__ */ React.createElement(Button, __spreadValues({
    p: 0,
    as,
    "aria-label": label,
    ref,
    size
  }, props), cloneElement(iconElement, { size: getButtonIconSize(size) })));
});
IconButton.displayName = "IconButton";

export { IconButton };
//# sourceMappingURL=IconButton.es.js.map
